'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function GTMTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Only run on page load
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_type: '/institucional' + pathname,
      currency: 'BRL',
    });
  }, [pathname]);

  return null;
}
